module.exports = __webpack_public_path__ + "img/speak-out.fa69aacc.png";